document.addEventListener("DOMContentLoaded", function () {
  const indexToKeyMap = new Map([
    [-4, "minus4_image"],
    [-3, "minus3_image"],
    [-2, "minus2_image"],
    [-1, "minus1_image"],
    [0, "zero_image"],
    [1, "plus1_image"],
    [2, "plus2_image"],
    [3, "plus3_image"],
    [4, "plus4_image"],
  ]);
  const modes = getModes();
  const unitState = {
    level: 0, // -4 -3 -2 -1 0 1 2 3 4
    mode: modes[1], // eco city sport sport+
  };
  const levelButtons = document.querySelectorAll(".level-button");
  const mainButton = document.querySelector(".main-button");
  const modeLights = document.querySelectorAll(".light");
  const levelLights = document.querySelectorAll(".level-light");
  const tabs = document.querySelectorAll(".p-info-action-tab");

  mainButton.addEventListener("click", function () {
    const activeMode = unitState.mode;
    const nextMode = modes[(modes.indexOf(activeMode) + 1) % modes.length];
    unitState.mode = nextMode;
    unitState.level = 0;
    handleLevelLights();
    handleModeLight();
    changeTabContent();
    preloadPrevNextImage();
  });

  preloadPrevNextImage();
  levelButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const target = button.classList.contains("minus-button")
        ? "minus"
        : "plus";

      const currentLevel = unitState.level;
      const nextLevel =
        target === "minus"
          ? Math.max(-4, currentLevel - 1)
          : Math.min(4, currentLevel + 1);

      unitState.level = nextLevel;
      handleLevelLights();
      changeTabContent();
      preloadPrevNextImage();
    });
  });

  function handleLevelLights() {
    levelLights.forEach((light) => {
      light.classList.remove("green");
      light.classList.remove("red");
    });
    if (unitState.level === 0) return;
    const isLevelPositive = unitState.level > 0;
    const targetLightIndex = isLevelPositive
      ? unitState.level - 1
      : unitState.level + 4;
    const targetLight = levelLights[targetLightIndex];
    targetLight.classList.add(isLevelPositive ? "green" : "red");
  }

  function handleModeLight() {
    const activeModeIndex = modes.indexOf(unitState.mode);
    modeLights.forEach((light, index) => {
      if (index === activeModeIndex) {
        light.classList.add("visible");
        return;
      }
      light.classList.remove("visible");
    });
  }
  function changeTabContent() {
    const activeTab = getActiveTab();
    if (activeTab.dataset.mode === unitState.mode) {
      changeTabImage(activeTab);
      return;
    }

    const nextTab = Array.from(tabs).find(
      (tab) => tab.dataset.mode === unitState.mode
    );
    changeTabImage(nextTab);
    setTimeout(() => {
      activeTab.classList.add("hidden");
      nextTab.classList.remove("hidden");
      console.log("call -> hidden")
    }, 150);
  }

  function changeTabImage(tab) {
    const imageElement = tab.querySelector("img");
    const settings = JSON.parse(tab.dataset.settings);
    const key = indexToKeyMap.get(unitState.level);
    const imageSource = settings[key];
    imageElement.src = imageSource;
  }

  function getActiveTab() {
    const activeTab = Array.from(tabs).find(
      (tab) => !tab.classList.contains("hidden")
    );
    return activeTab;
  }

  function preloadPrevNextImage() {
    const activeTab = getActiveTab();
    if (!activeTab) return;
    const settings = JSON.parse(activeTab.dataset.settings);
    const nextKey = indexToKeyMap.get(unitState.level + 1);
    const prevKey = indexToKeyMap.get(unitState.level - 1);
    const nextImage = settings[nextKey];
    const prevImage = settings[prevKey];
    if (nextImage) {
      const nextImageElement = new Image();
      nextImageElement.src = nextImage;
    }
    if (prevImage) {
      const prevImageElement = new Image();
      prevImageElement.src = prevImage;
    }
  }

  function getModes() {
    const tabs = document.querySelectorAll(".p-info-action-tab");
    return Array.from(tabs).map((tab) => tab.dataset.mode);
  }
});
